import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";
import React, { PureComponent } from "react";
import { reduxForm } from "redux-form/immutable";

import BasePage from "app/components/BasePage";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import { initializeEmployeeForm } from "features/planner/employee/employee.actions";
import { UPDATE_EMPLOYEE_FORM } from "features/planner/employee/employee.constants";
import { getEmployeeCardFromState } from "features/planner/employee/employee.selectors";

class EmployeeNextOfKinContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, employeeCard } = this.props;

    dispatchOnLoad(employeeCard.get("employee"));
  }

  render() {
    const { Icon, breadcrumb } = this.props;

    return (
      <BasePage Icon={Icon} title={breadcrumb}>
        <Grid container direction="column" item xs={12} lg={6}>
          <Grid item>
            <Field
              label="Name"
              defaultValue="-"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.NEXT_OF_KIN_NAME}
            />
          </Grid>
          <Grid item>
            <Field
              label="Address"
              defaultValue="-"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.NEXT_OF_KIN_ADDRESS}
            />
          </Grid>
          <Grid container>
            <Grid item xs={6} style={{ paddingRight: 16 }}>
              <Field
                label="City"
                defaultValue="-"
                component={ReadOnlyField}
                name={UPDATE_EMPLOYEE_FORM.NEXT_OF_KIN_CITY}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                label="Zip code"
                defaultValue="-"
                component={ReadOnlyField}
                name={UPDATE_EMPLOYEE_FORM.NEXT_OF_KIN_ZIP_CODE}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6} style={{ paddingRight: 16 }}>
              <Field
                label="Phone 1"
                defaultValue="-"
                component={ReadOnlyField}
                name={UPDATE_EMPLOYEE_FORM.NEXT_OF_KIN_PHONE1}
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                label="Phone 2"
                defaultValue="-"
                component={ReadOnlyField}
                name={UPDATE_EMPLOYEE_FORM.NEXT_OF_KIN_PHONE2}
              />
            </Grid>
          </Grid>
          <Grid item>
            <Field
              label="Type"
              defaultValue="-"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.NEXT_OF_KIN_TYPE}
            />
          </Grid>
        </Grid>
      </BasePage>
    );
  }
}

export default compose(
  connect(
    (state, { employeeCardId }) => ({
      employeeCard: getEmployeeCardFromState(state, employeeCardId),
    }),
    {
      dispatchOnLoad: initializeEmployeeForm,
    },
  ),
  reduxForm({
    form: UPDATE_EMPLOYEE_FORM.ID,
  }),
)(EmployeeNextOfKinContainer);
